const centerMapOnPopup = (map, popup) => {
  const el = popup.getElement();
  const offset = [0, el.offsetHeight / 2] || 0;
  const center = popup.getLngLat();
  map.easeTo({ center, offset });
};

export default centerMapOnPopup;
